// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FR-z","isFullWidth":"GR-z","landingPageVideo":"HR-z","play":"IR-z","iframeVideo":"JR-z","playHidden":"KR-z","fullwidth":"LR-z"};